const SECRET_KEY = 'C0mp0n3nt@-S3cr3t-K3y-2026';

function generateKey(secret: string): number[] {
    const keys: number[] = [];
    for (let i = 0; i < secret.length; i++) {
        keys.push(secret.charCodeAt(i));
    }
    return keys;
}

export function encrypt(data: object | any[]): string {
    const json = JSON.stringify(data);
    const bytes = new TextEncoder().encode(json);
    const keys = generateKey(SECRET_KEY);
    const encrypted = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
        encrypted[i] = bytes[i] ^ keys[i % keys.length];
    }
    let binary = '';
    encrypted.forEach(b => binary += String.fromCharCode(b));
    return btoa(binary);
}

export function decrypt(encoded: string): any {
    try {
        const binary = atob(encoded);
        const keys = generateKey(SECRET_KEY);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i) ^ keys[i % keys.length];
        }
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch {
        return null;
    }
}

export function saveUser(user: object): void {
    localStorage.setItem('user', encrypt(user));
}

export function getUser(): any {
    const stored = localStorage.getItem('user');
    if (!stored) return null;
    return decrypt(stored);
}

export function removeUser(): void {
    localStorage.removeItem('user');
}
